import { motion } from 'framer-motion';
import { COLORS, EASING, ANIM } from '../constants/theme';

const features = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L4 6v6c0 5 3.5 9.7 8 11 4.5-1.3 8-6 8-11V6L12 2z"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
    ),
    title: 'AI Strategy & Discovery',
    desc: 'Enterprise-ready AI solutions built for secure and scalable business deployment.',
    accent: COLORS.blue,
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M12 2v2m0 16v2M2 12h2m16 0h2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M4.9 19.1l1.4-1.4m11.4-11.4 1.4-1.4"/>
      </svg>
    ),
    title: 'Model Acceleration',
    desc: 'Build custom AI copilots, intelligent workflows, and model integrations tailored to your stack.',
    accent: COLORS.blueDark,
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="10" rx="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        <circle cx="12" cy="16" r="1.5" fill="currentColor" stroke="none"/>
      </svg>
    ),
    title: 'Secure Deployment',
    desc: 'Deploy in cloud or on-prem with governance, observability, and enterprise controls.',
    accent: COLORS.blueDeep,
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 18 8 13 12 15 20 6"/>
        <polyline points="16 6 20 6 20 10"/>
      </svg>
    ),
    title: 'Continuous Optimization',
    desc: 'We monitor model and workflow performance to keep quality and ROI improving over time.',
    accent: COLORS.blue,
  },
];

export default function Features() {
  return (
    <section id="features" style={{ padding: '96px 0', background: COLORS.bg }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, ease: EASING.spring }}
          style={{ marginBottom: 56, maxWidth: 560 }}
        >
          <div className="section-eyebrow">Why Reano AI</div>
          <h2 className="section-title" style={{ marginBottom: 14 }}>Why Reano AI Technologies</h2>
          <p className="section-sub">
            We combine strategy, engineering, and AI expertise to deliver reliable solutions that create measurable business value.
          </p>
        </motion.div>

        <motion.div
          variants={ANIM.stagger} initial="hidden" whileInView="visible"
          viewport={{ once: true, margin: '-40px' }}
          style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}
        >
          {features.map(f => (
            <motion.div key={f.title} variants={ANIM.staggerItem} className="card" style={{ padding: '32px 28px', borderTop: `3px solid ${f.accent}` }}>
              <div style={{
                width: 50, height: 50, borderRadius: 13,
                background: `${f.accent}12`, color: f.accent,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                marginBottom: 20,
              }}>
                {f.icon}
              </div>
              <h3 style={{ fontSize: 17, fontWeight: 700, letterSpacing: '-.02em', color: COLORS.text, marginBottom: 10 }}>{f.title}</h3>
              <p style={{ fontSize: 14.5, color: COLORS.text2, lineHeight: 1.65 }}>{f.desc}</p>
              <div style={{ marginTop: 20, display: 'flex', alignItems: 'center', gap: 5, fontSize: 13.5, fontWeight: 600, color: f.accent }}>
                Learn more
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M2 6.5h9M7.5 3l3 3.5-3 3"/>
                </svg>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
